import styled from 'styled-components';
import TextareaAutoheight from '@sdk/components/forms/TextareaAutoheight';
import { CheckboxBorder } from '@sdk/components/forms/Checkbox';
import CloseIcon from '@sdk/components/ui/CloseIcon';

import { MIN_ROW_HEIGHT } from '@web/shiftTasks/ComposeTask/constants';

export const RemoveSubtaskButton = styled(CloseIcon)`
  align-items: center;
  grid-area: remove;
  justify-content: center;
  place-self: stretch stretch;
`;

export const SubtaskContainer = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  cursor: move;
  column-gap: 10px;
  display: grid;
  grid-template:
    'checkbox title remove' auto
    'separator separator separator' 1px / min-content 1fr 32px;
  justify-content: center;
  min-height: ${MIN_ROW_HEIGHT}px;
  padding: 0 10px;

  ${RemoveSubtaskButton}:not(:hover) {
    display: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.hoverBrand};

    ${RemoveSubtaskButton} {
      display: flex;
    }
  }

  &::after {
    background-color: ${({ theme }) => theme.colors.separatorOnWhite};
    content: '';
    grid-area: separator;
    height: 1px;
  }
`;

export const SubtaskField = styled(TextareaAutoheight)`
  background-color: transparent;
  border: none;
  border-radius: 0;
  grid-area: title;
  padding: 0;
  user-select: none;
`;

export const CheckboxMock = styled(CheckboxBorder)`
  grid-area: checkbox;
  opacity: 0.5;
`;
